export enum MediaType {
  IMAGE = 'IMAGE',
  MAIN_PRODUCT_IMAGE = 'MAIN_PRODUCT_IMAGE',
  CONTEXT_PRODUCT_IMAGE = 'CONTEXT_PRODUCT_IMAGE',
  FUNCTIONAL_PRODUCT_IMAGE = 'FUNCTIONAL_PRODUCT_IMAGE',
  INSPIRATIONAL_IMAGE = 'INSPIRATIONAL_IMAGE',
  QUALITY_PRODUCT_IMAGE = 'QUALITY_PRODUCT_IMAGE',
  MEASUREMENT_ILLUSTRATION = 'MEASUREMENT_ILLUSTRATION',
  NON_STANDARDIZED_PRODUCT_IMAGE = 'NON_STANDARDIZED_PRODUCT_IMAGE',
  IMPORTED_PRODUCT_IMAGE = 'IMPORTED_PRODUCT_IMAGE',
  CUT_THROUGH_PRODUCT_IMAGE = 'CUT_THROUGH_PRODUCT_IMAGE',
  UPLOAD = 'UPLOAD',
}

export type Media = {
  displayOrder: number
  type: MediaType
  url: string
  note?: string
}
